import { observer } from 'mobx-react-lite';
import { EntityItem } from './entity-item';
import { useOpenAttachmentsPanel } from '../../../attachments/use-open-attachments-panel';
import { WorkspacePanel } from '../../workspace-panel';
import { AttachmentsPanelType } from '../../../attachments/types';

export const AttachmentsItem = observer(
    (props: {
        isHistorical?: boolean;
        title: string;
        entityId?: number;
        entityType: AttachmentsPanelType;
        entityNumber?: string;
        workspacePanel?: WorkspacePanel;
    }) => {
        const openAttachmentsPanel = useOpenAttachmentsPanel();

        return (
            <EntityItem
                title={props.title}
                icon="Paperclip"
                isPanelFocused={!!props.workspacePanel?.isFocused}
                entityNumber={props.entityNumber}
                onClick={() => {
                    if (props.isHistorical) {
                        openAttachmentsPanel({
                            entityId: props.entityId,
                            entityType: props.entityType,
                            entityNumber: props.entityNumber,
                            shouldFocus: true,
                        });
                    } else {
                        props.workspacePanel?.focus?.();
                    }
                }}
                onClose={props.workspacePanel ? () => props.workspacePanel?.close?.() : undefined}
            />
        );
    }
);
